export const verifyParam = (params, param) => {
  return params?.filter(({ parameter: p }) => p === param)?.length > 0 ? true : false;
};

export const paramValue = (params, param) => {
  return params?.filter(({ parameter: p }) => p === param)?.[0]?.value;
};

export const getPendingStatus = (limitDateString) => {
  if (!limitDateString) {
    return '';
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const limitDay = new Date(limitDateString);
  limitDay.setHours(0, 0, 0, 0);

  return (
    limitDay.getTime() === today.getTime() ? 'deadline'
    : limitDay < today ? 'overdue'
    : 'on_time_awaiting'
  );
};
